import { render, staticRenderFns } from "./UiSwiperCarousel.vue?vue&type=template&id=4b9f7e26&scoped=true&"
import script from "./UiSwiperCarousel.vue?vue&type=script&lang=js&"
export * from "./UiSwiperCarousel.vue?vue&type=script&lang=js&"
import style0 from "./UiSwiperCarousel.vue?vue&type=style&index=0&id=4b9f7e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f7e26",
  null
  
)

export default component.exports